import { render, staticRenderFns } from "./PurchaseAveragePricetable.vue?vue&type=template&id=6f2f1526&scoped=true&"
import script from "./PurchaseAveragePricetable.vue?vue&type=script&lang=js&"
export * from "./PurchaseAveragePricetable.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseAveragePricetable.vue?vue&type=style&index=0&id=6f2f1526&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2f1526",
  null
  
)

export default component.exports